import React, {useState, useEffect, useContext, useRef} from 'react';
import {useHistory} from 'react-router';
import { useLocation, Link } from 'react-router-dom'
import { AiOutlineMenu, AiOutlinePlus, AiOutlineHome, AiOutlineBell, AiOutlineInfoCircle, AiOutlineSearch, AiOutlineUser} from "react-icons/ai";
import { RiDashboardLine } from 'react-icons/ri'
import {BsGear} from 'react-icons/bs';

import useStyles from './styles'
import Modal from '../Modal';
import TextInput from '../TextInput';
import Select from '../Select';
import OptionsBaloom from '../OptionsBaloom';
import BallClickEffect from '../BallClickEffect';

import AppContext from '../../redux/contexts/appContext';
import api from '../../services/api';
import Cookies from '../../util/cookies';
import Public from '../../util/public';
import config from '../../enviroment/config.json';


function Header({subPages, selectedSubPage, onSubPageChange, roomJoin, newBoard}) {
  const classes = useStyles();
  const [modalVisible, setModalVisible] = useState(false);
  const [findModalVisible, setFindModalVisible] = useState(false);
  const [newBoardModalVisible, setNewBoardModalVisible] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const navLinks = [
    {name: "Home", to: "/", alt: "/room", icon: <AiOutlineHome/>},
    // {name: "Scrum Board", to: "/scrum-board",  icon: <RiDashboardLine />},
    // {name: "Notifications", to: "/notifications", icon: <AiOutlineBell/>},
     {name: "Settings", to: "/settings", icon: <BsGear/>},
    // {name: "Informations", to: "/info", icon: <AiOutlineInfoCircle/>}
  ]
  const location = useLocation();
  const history = useHistory();

  const [selectedSubPageState, setSelectedSubPage] = useState(selectedSubPage || 0);
  const [userOptionsOpen, setUserOptionsOpen] = useState(false);
  const [roomJoinOptionsOpen, setRoomJoinOptionsOpen] = useState(false);
  const [logOutModal, setLogOutModal] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [roomType, setRoomType] = useState("1");

  const {state, dispatch} = useContext(AppContext);

  const userSettingsRef = useRef(null);
  const roomJoinRef = useRef(null);



  const handleOutsideClick = (event) => {
    if (userSettingsRef.current && !userSettingsRef.current.contains(event.target)) {
      setUserOptionsOpen(false);
    } 
    if (roomJoinRef.current && !roomJoinRef.current.contains(event.target)) {
      setRoomJoinOptionsOpen(false);
    }

  }

  const closeMessageModal = () => {
    setModalMessage(null);
  }

  const handleSubPageChange = (to) => {
    setSelectedSubPage(to);
    if (onSubPageChange) onSubPageChange(to);
  }

  const handleFindRoomClick = () => {
    setFindModalVisible(true);
  }
  const handleFindRoomCancel = () => {
    setFindModalVisible(false);

  }

  const handleLogout = () => {
    Cookies.delete('token');
    Cookies.delete('UID');
    dispatch({type: 'set-user', payload: {}});
    history.push('/');
    history.go();
    setLogOutModal(false);
  }
  const handleLogoutCancel = () => {
    setLogOutModal(false);
  }


  const handleFindRoomSubmit = (values) => {
    setLoading(true);
    api().post(`/room/${values.roomCode.toLowerCase()}/member/add/${state.user.id}`)
    .then(response => {
      setModalVisible(false)
      setLoading(false);
      var roomId = response.data.result.roomId;
      var toUrl = '/room/'+roomId
      if (history.location.pathname.indexOf("room") !== -1) {
        history.push(toUrl);
        history.go();
      }
      else {
        history.push(toUrl);
      }
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setModalMessage(err.response.data.msg);
      }
      else {
        setModalMessage("Internal Server Error");
        setModalVisible(false)
      }
    })
  }

  const handleCreateRoomClick = () => {
    setModalVisible(true);
  }

  const handleCreateBoardClick = () => {
    setNewBoardModalVisible(true);
  }

  const handleCreateBoardSubmit = (values) => {
    setLoading(true);
    api().post('/board', values)
    .then(response => {
      setModalVisible(false)
      setLoading(false);
      var toUrl = '/scrum-board/'+response?.data?.result?._id
      if (history.location.pathname.indexOf("scrum-board") !== -1) {
        history.push(toUrl);
        history.go();
      }
      else {
        history.push(toUrl);
      }
      
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setModalMessage(err.response.data.msg);
      } 
      else {
        setModalMessage("Internal Server Error");
        setModalVisible(false)
      }
    })
  } 

  const handleCreateRoomCancel = () => {
    setModalVisible(false);
  }
  const handleCreateBoardCancel = () => {
    setNewBoardModalVisible(false);
  }
  
  const handleCreateRoomSubmit = (values) => {
    setLoading(true);
    api().post('/room', values)
    .then(response => {
      setLoading(false);
      setModalVisible(false)
      var toUrl = '/room/'+response?.data?.result?._id
      if (history.location.pathname.indexOf("room") !== -1) {
        history.push(toUrl);
        history.go();
      }
      else {
        history.push(toUrl);
      }
      
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setModalMessage(err.response.data.msg);
      } 
      else {
        setModalMessage("Internal Server Error");
        setModalVisible(false)
      }
    })
  }

  const switchNav = () => {
    setNavOpen(!navOpen);
  }

  useEffect(() => {
  }, [])

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <>

      <header className={classes.header} style={state.theme === "dark" ? {backgroundColor: '#1e1e1e', color: 'white'} : {}}>
        <div className={classes.headerLeft}>
          <div className={classes.headerIcon} onClick={switchNav}>
            <AiOutlineMenu></AiOutlineMenu>
          </div>
          <Link to={"/"} className={classes.logo}>
            <img src={Public("icons/white-icon.png")} alt="Easy Scrum Logo"></img>
          </Link>
        </div>

        {subPages && subPages.length > 0 && (
          <div className={classes.headerMiddle}>
            {subPages && subPages.map((page, index) => {
              return(
                <a key={"header-subpage-"+index} onClick={() => handleSubPageChange(index)}>
                  {page}
                  {selectedSubPageState === index && <div className={classes.selection}></div>}
                </a>  
              )
            })}
          </div> 
        )}
        

        <div className={classes.headerRight}>
          {roomJoin && (
            <OptionsBaloom.Container ref={roomJoinRef}>
              <BallClickEffect selected={roomJoinOptionsOpen} style={{marginLeft: 10, borderRadius: 50}}>
                <div  className={classes.headerIcon} onClick={() => setRoomJoinOptionsOpen(!roomJoinOptionsOpen)}>
                <AiOutlinePlus ></AiOutlinePlus>
                
                </div>
              </BallClickEffect>
              <OptionsBaloom 
                top={50} 
                open={roomJoinOptionsOpen} 
                options={[
                  {text: "Create new room", onClick: () => handleCreateRoomClick()},
                  // {text: "Notifications", onClick: () => {history.push('/notifications')}},
                  {text: "Find room", onClick: () => handleFindRoomClick()},
                ]}
              />
            </OptionsBaloom.Container>
          )}
          
          {newBoard && (
            <div className={classes.headerIcon} title="Create new board" onClick={handleCreateBoardClick}>
              <AiOutlinePlus ></AiOutlinePlus>
            </div>
          )}

          <div className={classes.userInfo} ref={userSettingsRef} onClick={() => setUserOptionsOpen(!userOptionsOpen)}>
            <div className={classes.userImage}>
              {state?.user?.char ? 
                <img src={`/chars/${state.user.char}.svg`} alt="User Character Image"></img>
                :
                <img src={"/chars/01.svg"} alt="User Character Image"></img>
              }
            </div>
            <span className={classes.userName}>
              {state?.user?.name}
            </span>
            <OptionsBaloom 
            top={65} 
            open={userOptionsOpen} 
            options={[
              {text: "Settings", onClick: () => {history.push('/settings')}},
              // {text: "Notifications", onClick: () => {history.push('/notifications')}},
              {text: "Log-out", onClick: () => {setLogOutModal(true)}},
            ]}
            />
          </div>          
        </div>
      </header>
      <nav className={classes.nav} style={{left: navOpen ? '0' : '-282px'}}>
        {navLinks.map((link, idx) => {
          return <Link key={"navlink-"+idx} onClick={switchNav} className={location.pathname === "/" && link.to === "/" ? "selected" : (location.pathname.indexOf(link.to) !== -1 && link.to !== "/") || (location.pathname.indexOf(link.alt) !== -1) ? "selected" : ""} to={link.to}>{link.icon}{link.name}</Link>

        })}
     
      </nav>
      <Modal loading={loading} title="Create Room" visible={modalVisible} onCancel={handleCreateRoomCancel} onSubmit={handleCreateRoomSubmit}>
          <TextInput startFocused name="title" label="Room Name" ></TextInput>
          <Select name="roomType" label="Room Type" onChange={(v) => {
            setRoomType(v);
          }} options={[{label: "Scrum Poken", value: 1}, {label: "Complexity X Effort", value: 2}]}></Select>
          {roomType === "1" && (
            <Select name="roomCards" label="Cards" options={[{label: "1, 2, 3, 5, 8, 13, 21, 34, 55, 89, Infinite", value: "1,2,3,5,8,13,21,34,55,89,Infinite"}, {label: "0, 1, 2, 4, 8, 16, 32, 64, Infinite", value: "0,1,2,4,8,16,32,64,Infinite"}]}></Select>
          )}
          <textarea name="description" placeholder="Description"></textarea>
      </Modal>
      <Modal loading={loading} title="Find Room" visible={findModalVisible} onCancel={handleFindRoomCancel} onSubmit={handleFindRoomSubmit}>
          <TextInput startFocused name="roomCode" className={classes.uppercase} label="Room Code" ></TextInput>
      </Modal>
      <Modal loading={loading} autoHeight title="Log-Out" visible={logOutModal} onCancel={handleLogoutCancel} onSubmit={handleLogout}>
          Do you really want to log out?
      </Modal>
      <Modal loading={loading} title="Create Board" visible={newBoardModalVisible} onCancel={handleCreateBoardCancel} onSubmit={handleCreateBoardSubmit}>
          <TextInput startFocused name="title" label="Board Name" ></TextInput>
          <textarea name="description" placeholder="Description"></textarea>
      </Modal>

      <Modal loading={loading} onCancel={closeMessageModal} visible={modalMessage !== null} title={"Alert"} submitText={"Ok"} cancelText={false} onSubmit={closeMessageModal}>
        {modalMessage}
      </Modal>

      {navOpen && (
        <div className={classes.filter} onClick={switchNav}></div>
      )}
    </>
  );
}

export default Header;